import React from 'react';
import { DynamicContentSection } from './DynamicContentSection';

export const AboutHeroSection: React.FC = () => {
  return (
    <DynamicContentSection 
      contentKey="About.hero"
      layout="image-right"
      showCta={false} // Hidden until destination page is created
      experience={{
        years: "+12",
        label1: "Years Of",
        label2: "experience"
      }}
    />
  );
};